import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CalendarComponent = _resolveComponent("CalendarComponent")
  const _component_AddBooking = _resolveComponent("AddBooking")

  return ($setup.isLoggedIn)
    ? (_openBlock(), _createBlock(_component_CalendarComponent, { key: 0 }))
    : (_openBlock(), _createBlock(_component_AddBooking, { key: 1 }))
}